import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import { useRouter } from 'react-resource-router';

import { getUserAccessUrlForRedirectWithContinueUrl } from '@townsquare/auth-utils';
import { NO_WORKSPACE_UPDATES_PATH, GOAL_FEED_PATH, PROJECT_FEED_PATH, HOME_PATH } from '@townsquare/config/routes';
// TODO [MISSING ICON]: add it to @atlaskit/icon-lab
import StatusIcon from '@townsquare/ds-icon/glyph/atlas/status';
// TODO [ICON]: New icon is too small for the nav item
import HomeIcon from '@townsquare/ds-icon/glyph/home';
import { homeTabRoute } from '@townsquare/hometab-view';
import { useGeneratePath } from '@townsquare/router/primitives';
import { SidebarNavigation } from '@townsquare/sidebar-navigation';
import { useWorkspaceStore } from '@townsquare/workspace-store';
import { yourWorkRoute } from '@townsquare/your-work-view/route';

export type NoWorkSpaceHomeSidebarNavigationProps = {
  isHome: boolean;
};

export const NoWorkspaceHomeSidebarNavigation = ({ isHome }: NoWorkSpaceHomeSidebarNavigationProps) => {
  const [routerStore] = useRouter();
  const { formatMessage } = useIntl();
  const [{ joinableWorkspaceIdentifier }] = useWorkspaceStore();
  const homePath = useGeneratePath(isHome ? homeTabRoute : yourWorkRoute);

  const NoWorkspaceHomeSideNavItems = [
    {
      key: HOME_PATH,
      path: homePath,
      name: formatMessage(isHome ? messages.home : messages.yourWork),
      icon: <HomeIcon label="" />,
    },
    {
      key: NO_WORKSPACE_UPDATES_PATH,
      path: joinableWorkspaceIdentifier
        ? getUserAccessUrlForRedirectWithContinueUrl(joinableWorkspaceIdentifier)
        : NO_WORKSPACE_UPDATES_PATH,
      matches: [PROJECT_FEED_PATH, GOAL_FEED_PATH, NO_WORKSPACE_UPDATES_PATH],
      name: formatMessage(messages.updates),
      icon: <StatusIcon label="" />,
    },
  ];

  const sections = [{ items: NoWorkspaceHomeSideNavItems }];

  return (
    <SidebarNavigation
      label={formatMessage(messages.sidebarLabel)}
      testId="updates-side-nav"
      sections={sections}
      selectedKey={routerStore.match.url}
    />
  );
};

const messages = defineMessages({
  yourWork: {
    id: 'townsquare.home-layout.noWorkspaceSidebar.yourWork',
    defaultMessage: 'Your work',
    description: 'Label for the no workspace sidebar your work item',
  },
  home: {
    id: 'townsquare.home-layout.noWorkspaceSidebar.home',
    defaultMessage: 'Home',
    description: 'Label for the no workspace sidebar home item',
  },
  updates: {
    id: 'townsquare.home-layout.noWorkspaceSidebar.updates',
    defaultMessage: 'Status Updates',
    description: 'Label for the no workspace sidebar status updates item',
  },
  sidebarLabel: {
    id: 'townsquare.home-layout.noWorkspaceSidebar.sidebarLabel',
    defaultMessage: 'Status Updates',
    description: 'Label for the updates sidebar',
  },
});
